export const Members = [
  {
    id: 1,
    name: 'Obi Wan Kenobi',
    imgSrc:
      'https://upload.wikimedia.org/wikipedia/en/3/32/Ben_Kenobi.png',
  },
  {
    id: 2,
    name: 'Darth Vader',
    imgSrc:
      'https://upload.wikimedia.org/wikipedia/en/f/f7/Darth_Vader.png',
  },
  {
    id: 3,
    name: 'Lando Calrissian',
    imgSrc:
      'https://upload.wikimedia.org/wikipedia/en/c/cb/Lando6-2.jpg',
  },
  {
    id: 4,
    name: 'Padme Amidala',
    imgSrc:
      'https://upload.wikimedia.org/wikipedia/en/e/ee/Amidala.png?20180113060156',
  },
  {
    id: 5,
    name: 'Darth Revan',
    imgSrc:
      'https://starwarsevreni.com/wp-content/uploads/2016/06/darth-revan-1_sw-evreni.jpg.webp',
  },
  {
    id: 6,
    name: 'Mace Windu',
    imgSrc: 'https://upload.wikimedia.org/wikipedia/en/b/bf/Mace_Windu.png',
  },
  {
    id: 7,
    name: 'Master Yoda',
    imgSrc:
      'https://upload.wikimedia.org/wikipedia/en/9/9b/Yoda_Empire_Strikes_Back.png',
  },
  {
    id: 8,
    name: 'Ahsoka Tano',
    imgSrc: 'https://upload.wikimedia.org/wikipedia/en/d/d7/Ahsoka_Tano.png',
  },
  {
    id: 9,
    name: 'Luke Skywalker',
    imgSrc: 'https://images6.alphacoders.com/874/874774.jpg',
  },
];
